export default "__VITE_ASSET__a45a62a4__"